import { makeStyles, createStyles, Typography, Collapse, Container, Theme } from '@material-ui/core';
import React, { FC, useEffect, useState } from 'react';
import Markdown from 'markdown-to-jsx';

import { FootnoteDefinition } from '../services/layout';

const useStyles = makeStyles(function (theme: Theme) {
  return createStyles({
    root: {
      flex: 1,
      margin: theme.spacing(0, 1),
    },
    button: {
      padding: 0,
      color: theme.palette.primary.main,
      border: 'none',
      background: 'none',
      textDecoration: 'underline',
      cursor: 'pointer',
      [theme.breakpoints.down('sm')]: {
        float: function (props: any) {
          return props.inline ? 'right' : 'none';
        }
      }
    },
    footnote: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
  });
});

// when text changes, this should close
export const Footnote: FC<FootnoteDefinition> = function (props) {
  const [ expanded, setExpanded ] = useState(false);
  const classes = useStyles(props);
  const buttonText = expanded
    ? props.hideLabel || 'Hide'
    : props.revealLabel || 'More Information';

  // a text change indicates a page change. If the text changes, re-close.
  useEffect(() => {
    setExpanded(false);
  }, [props.text])

  return (
    <div className = { classes.root }>
      <button
        className = { classes.button }
        onClick = { () => setExpanded(!expanded) }>
        <Typography variant = { 'caption' }>
          { buttonText }
        </Typography>
      </button>
      <Collapse collapsedHeight = { '0' } in = { expanded }>
        <Container className =  { classes.footnote }>
          <Markdown>
            { props.text ?? ''}
          </Markdown>
        </Container>
      </Collapse>
    </div>
  );
};
